import http from '@services/HTTP'
import type { EvaroPatientResponse, PatientListItem } from 'types/patient'

/** Patients owned by the logged-in user. A 404 means none yet. */
export const getPatientsList = async (): Promise<PatientListItem[]> => {
  try {
    const response = await http.get<EvaroPatientResponse[] | Record<string, EvaroPatientResponse>>('/patients')
    // The endpoint returns patients keyed by patient key when deduped; coerce to an array.
    const patients = (Array.isArray(response) ? response : Object.values(response ?? {})) as EvaroPatientResponse[]

    return patients.map(patient => ({
      ...patient,
      date_of_birth: typeof patient.date_of_birth === 'string' ? patient.date_of_birth : (patient.date_of_birth?.date?.split(' ')[0] ?? '')
    }))
  } catch (error: any) {
    if (error?.status === 404 || error?.response?.status === 404) {
      return []
    }
    throw error
  }
}
